import { AnimatedSection } from '@/hooks/useScrollAnimation';
import LazyYouTube from './LazyYouTube';
import { TESTIMONIAL_VIDEOS } from '@/data/testimonials';

type TestimonialVideo = {
  id: string | number;
  videoId: string;
  title?: string;
  name?: string;
  caption?: string;
};

interface TestimonialsProps {
  videos?: ReadonlyArray<TestimonialVideo>;
}

/**
 * Sem dado estruturado de avaliação aqui, de propósito.
 *
 * Até 04/08/2026 este componente emitia 32 objetos `Review` com `itemReviewed`
 * apontando para o proprio `@id` da clinica. Isso e avaliacao AUTO-HOSPEDADA:
 * coletada e exibida pelo negocio sobre si mesmo. O Google nao mostra rich
 * result de review nesse caso (LocalBusiness/Organization sobre si) e trata a
 * marcacao como spam de dados estruturados -- risco sem retorno nenhum.
 *
 * Os depoimentos continuam na pagina, em video: a prova social nao mudou, so
 * saiu a marcacao que o Google ja ia descartar. O 5,0 que vale de verdade vem
 * do Perfil da Empresa no Google, no painel de conhecimento.
 */
const Testimonials = ({ videos = TESTIMONIAL_VIDEOS }: TestimonialsProps) => {
  return (
    <AnimatedSection className="section-padding bg-secondary/30" id="depoimentos">
      <div className="container-mobile">
        {/* Header */}
        <div className="text-center mb-10">
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary/10 text-primary text-sm font-medium mb-4">
            Depoimentos
          </span>
          <h2 className="font-serif text-3xl md:text-4xl font-semibold text-foreground mb-3">
            Depoimentos de pacientes
          </h2>
          <p className="text-muted-foreground max-w-xl mx-auto">
            Veja o que nossos pacientes dizem sobre suas experiências na Clínica Habitus.
          </p>
        </div>

        {/* Testimonials Grid - Horizontal scroll on mobile */}
        <div className="flex gap-4 overflow-x-auto pb-4 scrollbar-hide snap-x snap-mandatory md:grid md:grid-cols-2 lg:grid-cols-4 md:overflow-visible">
          {videos.map((testimonial) => {
            const a11yTitle =
              testimonial.title ??
              (testimonial.name && testimonial.caption
                ? `Depoimento de ${testimonial.name} - ${testimonial.caption}`
                : `Depoimento ${testimonial.id}`);

            return (
              <figure
                key={testimonial.id}
                className="flex-shrink-0 w-[280px] md:w-auto snap-center"
              >
                {/* Lazy YouTube Embed */}
                <div className="relative aspect-[9/16] bg-muted rounded-xl overflow-hidden">
                  <LazyYouTube
                    videoId={testimonial.videoId}
                    title={a11yTitle}
                    className="absolute inset-0 w-full h-full"
                  />
                </div>

                {testimonial.name || testimonial.caption ? (
                  <figcaption className="pt-3">
                    {testimonial.name ? (
                      <p className="font-semibold text-foreground leading-tight">
                        {testimonial.name}
                      </p>
                    ) : null}
                    {testimonial.caption ? (
                      <p className="text-sm text-muted-foreground leading-snug">
                        {testimonial.caption}
                      </p>
                    ) : null}
                  </figcaption>
                ) : null}
              </figure>
            );
          })}
        </div>

        {/* Scroll indicator on mobile */}
        <div className="flex justify-center gap-2 mt-4 md:hidden">
          {videos.map((_, i) => (
            <div
              key={i}
              className="w-2 h-2 rounded-full bg-primary/30"
            />
          ))}
        </div>
      </div>
    </AnimatedSection>
  );
};

export default Testimonials;
